import { EDesktopListingActionType } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setListingStateVisible = actionGenerator<EDesktopListingActionType.SetVisible>(
  EDesktopListingActionType.SetVisible,
);

export const setListingStateHidden = actionGenerator<EDesktopListingActionType.SetHidden>(
  EDesktopListingActionType.SetHidden,
);
